"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PanelDocumentInfo = void 0;
var _react = _interopRequireDefault(require("react"));
var _panelDocumentInfoModule = _interopRequireDefault(require("./panel-document-info.module.scss"));
var _useTranslation2 = require("../../hooks/useTranslation/useTranslation");
var _DocumentPreview = require("../document-preview/DocumentPreview");
var _Button = require("../../elements/button/Button");
var _FileName = require("../file-components/file-name/FileName");
var PanelDocumentInfo = function PanelDocumentInfo(_ref) {
  var label = _ref.label,
    document = _ref.document,
    authorization = _ref.authorization,
    downloadDocument = _ref.downloadDocument;
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _panelDocumentInfoModule.default['panel-document-info']
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _panelDocumentInfoModule.default['panel-document-info__label']
  }, label), document ? /*#__PURE__*/_react.default.createElement("div", {
    className: _panelDocumentInfoModule.default['panel-document-info__details']
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _panelDocumentInfoModule.default['panel-document-info__preview']
  }, /*#__PURE__*/_react.default.createElement(_DocumentPreview.DocumentPreview, {
    type: document && document.fileName.includes('pdf') ? 'pdf' : 'img',
    file: document.location,
    authorization: authorization,
    disableModalView: true
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _panelDocumentInfoModule.default['panel-document-info__meta']
  }, /*#__PURE__*/_react.default.createElement(_Button.LinkButton, {
    className: _panelDocumentInfoModule.default['panel-document-info__link'],
    onClick: function onClick() {
      return downloadDocument(document.location, document.fileName);
    },
    "data-testid": "file-name-link"
  }, /*#__PURE__*/_react.default.createElement(_FileName.FileName, {
    name: document.fileName,
    className: _panelDocumentInfoModule.default['panel-document-info__filename']
  })), /*#__PURE__*/_react.default.createElement(_Button.NeutralButton, {
    small: true,
    onClick: function onClick() {
      return downloadDocument(document.location, document.fileName);
    }
  }, t('panelDocumentInfo.download')))) : /*#__PURE__*/_react.default.createElement("div", null, t('panelDocumentInfo.noDocument')));
};
exports.PanelDocumentInfo = PanelDocumentInfo;